// import socketIOClient from "socket.io-client";
import io from "socket.io-client";
// import APP_Constant from "../constants";

// const socket = socketIOClient(APP_Constant.apiUrl, {
//   agent: false,
//   origins: "*:*",
//   secure: true,
//   rememberUpgrade: true,
//   transports: ["websocket", "pooling"],
//   rejectUnauthorized: false,
//   upgrade: true
// });

// export default socket;

import APP_Constant from "../constants";

const socket = io(APP_Constant.apiUrl, {
  transports: ["websocket"], // use WebSocket first, if available,
  agent: false,
  origins: '*:*',
  secure: true,
  rememberUpgrade: true,
  rejectUnauthorized: false,
  upgrade: true,
});

// socket.on("connect", function () {
//   console.log("Admin Socket Connected Via Main Socket");
//   socket.emit('join', "ADMINS");
// });

export default socket;
